const Crypto = require("crypto")
const uuid = require("uuid")

function md5Hash(str) {
  let byteArray = new Uint8Array(Crypto.createHash('md5').update(str, 'utf8').digest())
  return [...byteArray]
}

module.exports = {
  uuid(value, namespace) {
    if (value && namespace) return uuid.v3(md5Hash(value), md5Hash(namespace))
    else return uuid.v4()
  },
  kvHash(key, version) {
    return Crypto.createHash("sha1")
      .update(`${key}.${version}`)
      .digest("hex")
      .slice(0, 16)
  },
  checkPassword(password) {
    if (password.length < 8) {
      return "errLength";
    } else if (!(/.*[0-9]/.test(password))) {
      return "errNumber";
    } else if (!(/[A-Z]/.test(password))) {
      return "errUppercase";
    } else if (!/[A-Za-z0-9]/.test(password)) {
      return "errSpecialChar"
    } else if (!/.*[a-z]/.test(password)) {
      return "errLowercase"
    } else return true;
  }
}